import { useCallback } from "react";
import { isSafari } from "react-device-detect";
import ReactGA4 from "react-ga4";
import { useDispatch } from "react-redux";

import { sendMessageToExtension } from "../functions/sendMessageToExtension";
import { addAlert } from "../redux/message/messageSlice";
import { AppDispatch } from "../redux/store";
import { User } from "../redux/user/userSlice";

type UseInitImportProps = {
  user: User;
};

export const useInitImport = ({ user }: UseInitImportProps) => {
  const dispatch = useDispatch<AppDispatch>();
  const initImport = useCallback(async () => {
    if (!user.uuid) {
      dispatch(
        addAlert({
          type: "error",
          title: "Club import",
          description: "Please login to import the club.",
        }),
      );
      ReactGA4.event({
        category: "Club import error",
        action: "User must be logged in to import",
      });
      return Promise.reject(new Error("User must be logged in to import."));
    }
    if (!window.chrome && !isSafari) {
      dispatch(
        addAlert({
          type: "error",
          title: "Club import",
          description:
            "Please use a Google Chrome browser to perform the import.",
        }),
      );
      ReactGA4.event({
        category: "Club import error",
        action: "Google Chrome is required.",
      });
      return Promise.reject(new Error("Google Chrome is required."));
    }

    try {
      await sendMessageToExtension({ user });
    } catch (error) {
      dispatch(
        addAlert({
          type: "error",
          title: "Club import",
          description: error.message,
        }),
      );
      ReactGA4.event({
        category: "Club import error",
        action: "Chrome Extension is required.",
      });
      return Promise.reject(new Error("Chrome Extension is required."));
    }
  }, [dispatch, user]);

  return initImport;
};
